import moment from 'moment';
import { IClubTransaction } from '../../../../store/admin/clubs/store';
import { getFormattedTransactionData } from './getFormattedTransactionData';

export const filterTransactions = (
  selectedEventNameFilterOption: any,
  selectedPayeerFilterOption: any,
  selectedTypeFilterOption: any,
  selectedDateStartFilterOption: any,
  selectedDateEndFilterOption: any,
  transaction: IClubTransaction
) => {
  const { created } = transaction;

  const formattedCreatedDate = moment(created);

  const { eventName, payeer, type } = getFormattedTransactionData(transaction);

  return (
    (!selectedEventNameFilterOption || eventName === selectedEventNameFilterOption) &&
    (!selectedPayeerFilterOption || payeer === selectedPayeerFilterOption) &&
    (!selectedTypeFilterOption || type === selectedTypeFilterOption) &&
    (!selectedDateStartFilterOption ||
      formattedCreatedDate.isAfter(selectedDateStartFilterOption)) &&
    (!selectedDateEndFilterOption || formattedCreatedDate.isBefore(selectedDateEndFilterOption))
  );
};
